import React from 'react';
import SpeedReaderComponent from '../components/reader/SpeedReader';
import { Box } from '@mui/material';

const SpeedReader = () => {
  return (
    <Box>
      <SpeedReaderComponent />
    </Box>
  );
};

export default SpeedReader;
